<mat-card>
  <mat-card-content>
    <mat-form-field>
      <mat-label>Tipo de {{ 'Invoice' | human }}</mat-label>
      <mat-select [(ngModel)]="invoiceType" (ngModelChange)="onTypeSelected()">
        @for(type of TYPES; track type) {
          <mat-option value="{{type}}">{{ type | human }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-card-content>
</mat-card>

@if (!loading()) {
  @if (roleService.can('read','admin') | async) {
    <app-status-form
      [type]="'Status::' + invoiceType()"
      title="Estados de {{ 'Invoice' | human }}"
      [showStatuses]="true"
      [showTransitions]="true">
    </app-status-form>
  }
  
  <app-work-form [model]="invoiceType()"></app-work-form>
  <app-client-notification-form [model]="invoiceType()"></app-client-notification-form>
}
